import { DEFAULT_MAX_TRAVEL_DISTANCE } from '~containers/operations/default-operations';

export const searchCriteria = ({
  location,
  filters = {},
  currency,
  maxDistance = DEFAULT_MAX_TRAVEL_DISTANCE,
  pagination,
  order,
  newMatches,
}) => {
  const result = {};

  if (location && location.latitude && location.longitude) {
    result.latitude = location.latitude;
    result.longitude = location.longitude;
  }

  if (currency && typeof filters.price === 'number') {
    result.currency = currency;
    result.amount = filters.price;
  }

  if (filters.attributes) {
    result.attributes = filters.attributes;
  }
  if (filters.languages) {
    result.languages = filters.languages;
  }
  if (filters.days) {
    result.days = filters.days;
  }

  result['max-distance'] = (filters.maxDistance != null) ? filters.maxDistance : maxDistance;

  if (order) {
    if (order.direction) {
      result['order-direction'] = order.direction;
    }
    if (order.value) {
      result['order-type'] = order.value;
    }
  }

  if (pagination) {
    result['pagination-limit'] = pagination.limit;
    result['pagination-offset'] = pagination.offset;
  }

  if (newMatches?.newMatchesMode) {
    result['new-matches'] = true;
    if (newMatches.notificationId) {
      result['notification-id'] = newMatches.notificationId;
    }
  }

  return result;
};
